"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = L10n;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useI18n = require("./useI18n");

var _L10nContext = _interopRequireDefault(require("./L10nContext"));

var propTypes = {
  /** Sets the preferred language */
  locale: _propTypes["default"].string,
  locales: _propTypes["default"].object
  /* eslint-disable-line react/forbid-prop-types */
  ,

  /** Children of the L10n */
  children: _propTypes["default"].node.isRequired
};
var defaultProps = {
  locale: "en",
  locales: null
};

function L10n(props) {
  var value = _react["default"].useMemo(function () {
    return (0, _useI18n.getI18nObject)(props.locale, props.locales);
  }, [props.locale, props.locales]);

  value.i18n.changeLanguage(props.locale);
  return /*#__PURE__*/_react["default"].createElement(_L10nContext["default"].Provider, {
    value: value
  }, props.children);
}

L10n.propTypes = propTypes;
L10n.defaultProps = defaultProps;
L10n.displayName = "L10n";
//# sourceMappingURL=L10n.js.map